import React, { useEffect, useState } from 'react';
import DataTable from '../../../components/DataTable/DataTable';
import { IColInfo } from '../../../components/DataTable/Interfaces';
import { ApplicationFunctions, useAuth } from '../../../contexts/authContext';
import { useNotifications } from '../../../contexts/notificationContext';
import DataService from "../../../services/data.service";
import { IdProps } from '../../../types/IdProps';
import AddEmployeePopup from '../Popups/ProductCategory_popup_AddEmployee';

const ProductCategory_tab_Employees: React.FC<IdProps> = ({ id }) => {
    const [data, setData] = useState<[]>();
    const [showPopup, setShowPopup] = useState<boolean>(false)
    const { handleResult, handleException } = useNotifications();
    const { isAuthorizedFor } = useAuth();

    useEffect(() => {
        getTableData();
    }, [id]);

    function getTableData() {
        DataService.get<[]>('api/v1/ProductCategoryEmployees/ByProductCategory/' + id)
            .then(response => {
                setData(response);
            })
            .catch(e => { handleException(e); });
    }

    function deleteRow(rowData) {
        DataService.delete('api/v1/ProductCategoryEmployees/', rowData.id)
            .then(response => {
                handleResult(response);
                getTableData();
            })
            .catch(e => { handleException(e); });
    }

    let colInfos: IColInfo[] = [
        { key: true, dataProp: 'employeeId', visible: false },
        { title: 'Name', dataProp: 'employee.user', dataType: 'user', sort: 'asc' },
        { title: 'Workflow role', dataProp: 'functionalRole.name' }
    ];
    if (isAuthorizedFor(ApplicationFunctions.EditProductCategory)) {
        colInfos.push(
            {
                headerButtons: [{ text: "Add", icon: 'fa-plus-square', color: '#26A69A', onClick: () => setShowPopup(true) }],
                rowButtons: [{ text: "Delete", icon: 'fa-trash', color: '#F3565D', onClick: deleteRow }]
            });
    }

    return (
        <>
            <DataTable
                name='dtProductCategoryEmployees'
                colInfos={colInfos}
                tableData={data}
                navigateTitle='Employee'
                navigateUrl='/plm/UserManagement/Employee/'
            />
            {showPopup && <AddEmployeePopup show={showPopup} onHide={() => { setShowPopup(false); getTableData(); }} productCategoryId={id} />}
        </>
    );
}
export default ProductCategory_tab_Employees;